import { useQuery } from '@tanstack/react-query'
import { accessControlApi } from '../api/access-control.client'

export const USER_QUERY_KEY = ['access-control', 'user'] as const

/**
 * One user's RBAC roles, for surfaces that show a single person rather than
 * the list. Skipped until an id is known and the caller says the viewer may
 * read it, so a viewer without Read on UserPermission never sees a 403.
 */
export function useUserQuery(
  cognitoUserId: string | undefined,
  enabled = true
) {
  return useQuery({
    queryKey: [...USER_QUERY_KEY, cognitoUserId],
    queryFn: () => accessControlApi.getUser(cognitoUserId ?? ''),
    enabled: enabled && Boolean(cognitoUserId),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
